import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import CreatableSelect from "react-select/creatable";
import { useClientePage } from "../../../../Context/ClientePage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { useUserInfor } from "../../../../Context/User";
import { EnviarBoletoPorEmailSiengeController } from "../../../../Controllers/Cobranca/Boleto/BoletoController";
import {
    GerarPdfESolutionController,
    GetArquivosBoletosDeListaParcela,
} from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import { ListarContatosController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import {
    ListarDocumentoTemplateController,
    SetVariaveisDocumentoController,
} from "../../../../Controllers/Geral/Documentos/DocumentosController";
import {
    EnviarEmailAnexoAbrindoCasoController,
    EnviarEmailAnexoController,
} from "../../../../Controllers/Geral/Email/EmailController";
import { ListarEmailContaPorUsuarioController } from "../../../../Controllers/Geral/Grupos/GruposEmailsController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    IParcelaBoletos,
    IParcelas,
} from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { ACESSOS } from "../../../../Routes/Acessos";
import { pdfMerger } from "../../../../Tools/PDFTools";
import { AlertError } from "../../../../Tools/SweetAlerts";
import OrSpinner from "../../../Utils/OrSpinner";
import Editor from "../../Forms/Editor";
import LazySelect from "../../Forms/LazySelect";
import { Switch } from "../../Forms/Switch";
import { CadastrarHistoricosController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import moment from "moment";
import { formatMoneyReais } from "../../../../Tools/FormatTools";

interface IEnviarBoletoPorEmailProps {
    parcelasRequest: IParcelas;

    lstParcelasBoletosRequest: Array<IParcelaBoletos>;
    setLstParcelasBoletosRequest(
        lstParcelasBoletosRequest: Array<IParcelaBoletos>
    ): void;
    setAlertText: (alertText: string) => void;

    lstParcelasMarcadas: Array<IParcelaBoletos>;

    ID_CASO?: number;
    ID_CONTA: number;
    idTipoCaso?: number;
}
interface PropsFormData {
    email_destinatario: string;
    email_remetente: number;
    assunto: string;
    file: Array<File>;
    cc: string;
    cco: string;
    ModeloEmail: number;
    agruparAnexo: boolean;
    DS_MENSAGEM: string;
}

export default function EnviarBoletoPorEmail(
    props: IEnviarBoletoPorEmailProps
) {
    const { lstParcelasBoletosRequest, setAlertText } = props;
    const [showEnviarEmail, setShowEnviarEmail] = useState(false);
    const [emailDestinatario, setEmailDestinatario] = useState<
        Array<string> | undefined
    >([]);
    const { id } = useModuloInfo();

    const { register, handleSubmit, formState, reset, control, setValue } =
        useForm();
    const { OrgInfor, UserInfor } = useUserInfor();
    const { idCaso: idCasoClientePage, setIdCaso: setIdCasoClientePage } =
        useClientePage();
    const { Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const siengeMode = OrgInfor.COD_ERP_INTEGRACAO === "SIENGE";
    const eSolutionMode =
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION" ||
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION_LIVA";
    const incorfastMode = OrgInfor.ID_ORGANIZACAO === "428F61C1-B8C2-4473-8A20-8F994F56D6F5";

    const { value: lstContatos, loading: lstContatosLoading } = useAsyncEffect(
        () => ListarContatosController(props.ID_CONTA, props.ID_CASO),
        [props.ID_CONTA]
    );

    const options = lstContatos?.map((contato) => ({
        label: `${contato.DS_EMAIL ? contato.DS_NOME : ""} ${contato.DS_EMAIL ? `<${contato.DS_EMAIL}>` : ""
            }`,
        value: contato.DS_EMAIL ?? "",
    }));

    function defaultValue() {
        return {
            value:
                lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                    ?.DS_EMAIL ?? "",
            label: `${lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                ?.DS_NOME ?? ""
                } <${lstContatos?.filter((c) => c.FL_PROPONENTE === true)[0]
                    ?.DS_EMAIL ?? ""
                }>`,
        };
    }

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
        }),
    };

    const {
        execute: listarDocumentosTemplateSimples,
        value: DocsTemplateSimples,
    } = useAsyncCallback(() => {
        return ListarDocumentoTemplateController({ idTipoCaso: id });
    }, [id]);

    const { execute: CadastrarHistorico, loading: CadastrarHistoricoLoading } =
        useAsyncCallback(CadastrarHistoricosController);

    const { execute: GerarPdfESolution, loading: GerarPdfESolutionLoading } =
        useAsyncCallback(GerarPdfESolutionController);

    const [assunto, setAssunto] = useState(0);

    const handleErase = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAssunto(Number(e.target.value));
    };

    const {
        execute: setVariaveisDocumento,
        loading: loadingVariaveisDocumento,
    } = useAsyncCallback(
        async (idDocumentoTemplateInput: string) => {
            if (props.ID_CASO) {
                await SetVariaveisDocumentoController(
                    Number.parseInt(idDocumentoTemplateInput),
                    props.ID_CASO,
                    props.idTipoCaso
                        ? props.idTipoCaso
                        : ACESSOS.ATENDIMENTO.ID_MODULO,
                    lstParcelasBoletosRequest[0]?.NumParc_Prc ?? 0
                ).then((res) => {
                    setValue("DS_MENSAGEM", res);
                });
            } else {
                await SetVariaveisDocumentoController(
                    Number.parseInt(idDocumentoTemplateInput),
                    0,
                    props.idTipoCaso
                        ? props.idTipoCaso
                        : ACESSOS.ATENDIMENTO.ID_MODULO,
                    lstParcelasBoletosRequest[0]?.NumParc_Prc ?? 0,
                    props.parcelasRequest.NR_EMPRESA +
                    "_" +
                    props.parcelasRequest.DS_OBRA +
                    "_" +
                    props.parcelasRequest.NR_VENDA
                ).then((res) => {
                    setValue("DS_MENSAGEM", res);
                });
            }
        },
        [props.ID_CASO, props.idTipoCaso, lstParcelasBoletosRequest]
    );

    async function enviarBoletoPorEmailSienge(
        assunto: string,
        destinatario: string,
        mensagem: string
    ) {
        await EnviarBoletoPorEmailSiengeController({
            DS_BODY_EMAIL: mensagem,
            DS_OBRA: props.parcelasRequest.DS_OBRA,
            NR_EMPRESA: props.parcelasRequest.NR_EMPRESA,
            NR_VENDA: props.parcelasRequest.NR_VENDA,
            DS_DESTINATARIO: destinatario,
            DS_TITULO_EMAIL: assunto,
            ID_CODIGO_PARCELA: lstParcelasBoletosRequest[0].NumParc_Prc,
        });
        reset();
        props.setLstParcelasBoletosRequest([]);
    }

    const valueAssunto = DocsTemplateSimples?.filter(
        (doc) => doc.ID_DOCUMENTO_TEMPLATE === assunto
    )[0]?.DS_ASSUNTO;

    const { execute: handleEnviarBoletoEmailFormSubmit, loading } =
        useAsyncCallback(async (formData: PropsFormData) => {
            if (siengeMode) {
                await enviarBoletoPorEmailSienge(
                    formData.assunto,
                    formData.email_destinatario,
                    formData.DS_MENSAGEM
                ).then((res) => {
                    props.lstParcelasMarcadas.filter((parc) => {
                        CadastrarHistorico({
                            DS_HISTORICO: `Boleto enviado ao cliente. Enviado por: ${UserInfor.DS_NOME
                                } / Data de vencimento: ${moment(
                                    parc.Data_Ven
                                ).format("LL")} / Valor: ${formatMoneyReais(
                                    parc.Valor_Prc
                                )} / Nº Remessa / Nº Documento ${parc.NumParcGer_Prc
                                } / Nº Parcela: ${parc.NumParc_Prc
                                } / Enviado para: ${emailDestinatario &&
                                    emailDestinatario.length > 0
                                    ? emailDestinatario
                                    : lstContatos?.filter(
                                        (c) => c.FL_PROPONENTE === true
                                    )[0]?.DS_EMAIL !== ""
                                        ? defaultValue().value
                                        : undefined
                                }`,
                            ID_CASO: props.ID_CASO ?? 0,
                            DT_CADASTRO: new Date().toISOString(),
                            ID_CASO_HISTORICO: 0,
                            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                                Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                            ID_ETAPA_TIPO_CASO: Atendimento?.ID_ETAPA_TIPO_CASO,
                            ID_USUARIO: UserInfor.ID_USUARIO ?? 0,
                        }).then(() => {
                            ReloadHistorico();
                        });
                        return true;
                    });
                });
            } else {
                const idCaso = props.ID_CASO ?? idCasoClientePage;
                if (eSolutionMode && lstParcelasBoletosRequest) {
                    GerarPdfESolution(
                        Atendimento?.NR_CPF ?? "",
                        lstParcelasBoletosRequest.map(
                            (lst) => lst.CODIGOBARRA ?? ""
                        )
                    ).then(async (res) => {
                        if (res) {
                            const pdfContent = atob(res);

                            const arrayBuffer = new ArrayBuffer(
                                pdfContent.length
                            );
                            const uint8Array = new Uint8Array(arrayBuffer);
                            for (let i = 0; i < pdfContent.length; i++) {
                                uint8Array[i] = pdfContent.charCodeAt(i);
                            }

                            const blob = new Blob([arrayBuffer], {
                                type: "application/pdf",
                            });

                            const lstArquivos = [blob];

                            const fileArray = lstArquivos.map(
                                (blob) => new File([blob], "boletos.pdf")
                            );

                            const req = {
                                File: fileArray,
                                DS_ASSUNTO: formData.assunto,
                                DS_MENSAGEM: formData.DS_MENSAGEM,
                                ID_CASO: idCaso,
                                ID_EMAIL_CONTA: formData.email_remetente,
                                DS_DESTINATARIO:
                                    (emailDestinatario?.length || 0) > 0
                                        ? emailDestinatario
                                        : lstContatos?.filter(
                                            (c) => c.FL_PROPONENTE === true
                                        )[0].DS_EMAIL ?? "",
                                DS_COPIA_CARBONO: formData.cc,
                                DS_COPIA_CARBONO_OCULTA: formData.cco,
                                ID_CHAVE_ERP: `${props.parcelasRequest.NR_EMPRESA}_${props.parcelasRequest.DS_OBRA}_${props.parcelasRequest.NR_VENDA}`,
                            };

                            let promise: Promise<any> | undefined;

                            promise = EnviarEmailAnexoController(req).then(
                                (res) => {
                                    return res;
                                }
                            );

                            await promise?.then(() => {
                                ReloadHistorico();
                                setAlertText(
                                    `Boleto${lstParcelasBoletosRequest.length > 1
                                        ? "s"
                                        : ""
                                    } enviado${lstParcelasBoletosRequest.length > 1
                                        ? "s"
                                        : ""
                                    } por e-mail com sucesso!`
                                );
                                reset();
                            });
                        }
                    });
                } else if (lstParcelasBoletosRequest.length) {
                    const LstBoletos = (await GetArquivosBoletosDeListaParcela(
                        lstParcelasBoletosRequest,
                        OrgInfor.COD_ERP_INTEGRACAO,
                        (b) => `BOLETO_${b.Banco_Bol}_${b.SeuNum_Bol}.pdf`
                    )) as Array<File> | undefined;
                    if (LstBoletos && LstBoletos.length > 0) {
                        let lstArquivos = LstBoletos;

                        if (formData.agruparAnexo) {
                            const mergedPDF = await pdfMerger(...LstBoletos);
                            lstArquivos = [
                                new File([mergedPDF], "BOLETOS.pdf"),
                            ];
                        }

                        if (
                            lstArquivos.length &&
                            (props.idTipoCaso || idCaso)
                        ) {
                            // preparando requisição
                            const req = {
                                File: lstArquivos,
                                DS_ASSUNTO: formData.assunto,
                                DS_MENSAGEM: formData.DS_MENSAGEM,
                                ID_CASO: idCaso,
                                ID_EMAIL_CONTA: formData.email_remetente,
                                DS_DESTINATARIO:
                                    (emailDestinatario?.length || 0) > 0
                                        ? emailDestinatario
                                        : lstContatos?.filter(
                                            (c) => c.FL_PROPONENTE === true
                                        )[0].DS_EMAIL ?? "",
                                DS_COPIA_CARBONO: formData.cc,
                                DS_COPIA_CARBONO_OCULTA: formData.cco,
                                ID_CHAVE_ERP: `${props.parcelasRequest.NR_EMPRESA}_${props.parcelasRequest.DS_OBRA}_${props.parcelasRequest.NR_VENDA}`,
                            };

                            let promise: Promise<any> | undefined;
                            if (idCaso)
                                promise = EnviarEmailAnexoController(req).then(
                                    (res) => {
                                        props.lstParcelasMarcadas.filter(
                                            (parc) => {
                                                CadastrarHistorico({
                                                    DS_HISTORICO: `Boleto enviado ao cliente. Enviado por: ${UserInfor.DS_NOME
                                                        } / Data de vencimento: ${moment(
                                                            parc.Boleto?.DataVenc_bol
                                                        ).format(
                                                            "LL"
                                                        )} / Valor: ${formatMoneyReais(
                                                            incorfastMode && parc.Boleto ?
                                                                parc.Boleto?.ValDoc_Bol :
                                                                parc.ValorReaj !== 0
                                                                    ? parc.ValorReaj
                                                                    : parc.Valor_Prc
                                                        )} / Nº Remessa / Nº Documento ${parc.NumParcGer_Prc
                                                        } / Nº Parcela: ${parc.NumParc_Prc
                                                        } / Enviado para: ${emailDestinatario &&
                                                            emailDestinatario.length >
                                                            0
                                                            ? emailDestinatario
                                                            : lstContatos?.filter(
                                                                (c) =>
                                                                    c.FL_PROPONENTE ===
                                                                    true
                                                            )[0]?.DS_EMAIL !==
                                                                ""
                                                                ? defaultValue()
                                                                    .value
                                                                : undefined
                                                        }`,
                                                    ID_CASO: idCaso,
                                                    DT_CADASTRO:
                                                        new Date().toISOString(),
                                                    ID_CASO_HISTORICO: 0,
                                                    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                                                        Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                                                    ID_ETAPA_TIPO_CASO:
                                                        Atendimento?.ID_ETAPA_TIPO_CASO,
                                                    ID_USUARIO:
                                                        UserInfor.ID_USUARIO ??
                                                        0,
                                                }).then(() => {
                                                    ReloadHistorico();
                                                });
                                                return true;
                                            }
                                        );
                                    }
                                );
                            else if (props.idTipoCaso) {
                                promise = EnviarEmailAnexoAbrindoCasoController(
                                    req,
                                    props.ID_CONTA,
                                    props.idTipoCaso
                                ).then((res) => {
                                    props.lstParcelasMarcadas.filter((parc) => {
                                        CadastrarHistorico({
                                            DS_HISTORICO: `Boleto enviado ao cliente. Enviado por: ${UserInfor.DS_NOME
                                                } / Data de vencimento: ${moment(
                                                    parc.Boleto?.DataVenc_bol
                                                ).format(
                                                    "LL"
                                                )} / Valor: ${formatMoneyReais(
                                                    incorfastMode && parc.Boleto ?
                                                        parc.Boleto?.ValDoc_Bol :
                                                        parc.Valor_Prc
                                                )} / Nº Remessa: ${parc.Boleto?.NumArq_Bol
                                                } / Nº Documento: ${parc.Boleto?.NumDoc_Bol
                                                } / Nº Parcela: ${parc.NumParc_Prc
                                                } / Enviado para: ${emailDestinatario &&
                                                    emailDestinatario.length > 0
                                                    ? emailDestinatario
                                                    : lstContatos?.filter(
                                                        (c) =>
                                                            c.FL_PROPONENTE ===
                                                            true
                                                    )[0]?.DS_EMAIL !== ""
                                                        ? defaultValue().value
                                                        : undefined
                                                }

                                                }`,
                                            ID_CASO: idCaso ?? 0,
                                            DT_CADASTRO:
                                                new Date().toISOString(),
                                            ID_CASO_HISTORICO: 0,
                                            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                                                Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                                            ID_ETAPA_TIPO_CASO:
                                                Atendimento?.ID_ETAPA_TIPO_CASO,
                                            ID_USUARIO:
                                                UserInfor.ID_USUARIO ?? 0,
                                        }).then(() => {
                                            ReloadHistorico();
                                        });
                                        return true;
                                    });
                                    setIdCasoClientePage(res.ID_CASO);
                                    return res;
                                });
                            }

                            await promise?.then(() => {
                                ReloadHistorico();
                                setAlertText(
                                    `Boleto${LstBoletos.length > 1 ? "s" : ""
                                    } enviado${LstBoletos.length > 1 ? "s" : ""
                                    } por e-mail com sucesso!`
                                );
                                reset();
                            });
                        } else {
                            AlertError(
                                `Não encontramos nenhum boleto selecionado!`,
                                "Favor selecionar pelo menos 1 parcela para enviar por e-mail."
                            );
                        }
                    } else {
                        return AlertError(
                            "Parcela(s) sem boleto!",
                            "Para enviar por e-mail, selecione parcelas com boleto gerado"
                        );
                    }
                } else {
                    AlertError(
                        `Selecione uma parcela!`,
                        "Favor selecionar pelo menos 1 parcela para enviar por e-mail."
                    );
                }
            }
        });

    return (
        <>
            <OrSpinner loading={lstContatosLoading} spinner="capys">
                {!siengeMode && (
                    <div className="d-flex justify-content-end align-itens-center">
                        <button
                            className="btn btn-outline-primary font-weight-bold"
                            type="button"
                            onClick={() => {
                                setShowEnviarEmail((prev) => !prev);
                            }}
                        >
                            Enviar Por Email
                            <FontAwesomeIcon
                                icon={faPaperPlane}
                                className="ml-3"
                                size="lg"
                            />
                        </button>
                    </div>
                )}
                <Collapse
                    in={
                        showEnviarEmail ||
                        (siengeMode &&
                            props.lstParcelasBoletosRequest.length > 0)
                    }
                >
                    <div>
                        <form
                            id="formEmail"
                            onSubmit={handleSubmit(
                                handleEnviarBoletoEmailFormSubmit
                            )}
                            className="w-100 align-itens-center "
                        >
                            <div className="row d-flex flex-wrap">
                                {!siengeMode && (
                                    <div className="col-12 col-lg-6 mt-2">
                                        <label>Email Remetente:</label>
                                        <LazySelect
                                            controller={
                                                ListarEmailContaPorUsuarioController
                                            }
                                            getDS={(e) => e.DS_REMETENTE}
                                            getKeyValue={(e) =>
                                                e.ID_EMAIL_CONTA
                                            }
                                            name="email_remetente"
                                            className={`form-control placeholder-dark-50  ${formState.errors
                                                .email_remetente &&
                                                "is-invalid"
                                                }`}
                                            ref={register({
                                                required:
                                                    "Insira o email do remetente",
                                                valueAsNumber: true,
                                            })}
                                        />
                                    </div>
                                )}

                                <div className="col-12 col-lg-6 mt-2">
                                    <label>Email Destinatário:</label>
                                    <CreatableSelect
                                        isMulti
                                        isClearable
                                        isSearchable
                                        onChange={(e) => {
                                            setEmailDestinatario(
                                                e.map((value) => value?.value)
                                            );
                                        }}
                                        formatCreateLabel={(value) =>
                                            `Clique para selecionar: ${value}`
                                        }
                                        styles={customStyles}
                                        placeholder={"Digite o email"}
                                        options={options}
                                        defaultValue={
                                            lstContatos?.filter(
                                                (c) => c.FL_PROPONENTE === true
                                            )[0]?.DS_EMAIL !== ""
                                                ? defaultValue()
                                                : undefined
                                        }
                                    />
                                </div>
                            </div>
                            {!siengeMode && (
                                <div className="row mb-3 d-flex flex-wrap">
                                    <div className="col-12 col-lg-6 mt-2">
                                        <label>Cópia Carbono:</label>
                                        <input
                                            type="text"
                                            name="cc"
                                            placeholder={
                                                "Digite o email para cópia"
                                            }
                                            className={`form-control px-0 p-2 placeholder-muted-75`}
                                            ref={register()}
                                        />
                                    </div>

                                    <div className="col-12 col-lg-6 mt-2">
                                        <label>Cópia Carbono Oculta:</label>
                                        <input
                                            type="text"
                                            name="cco"
                                            placeholder={
                                                "Digite o email para cópia oculta"
                                            }
                                            className={`form-control px-0 p-2 placeholder-muted-75`}
                                            ref={register()}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="row mb-3 d-flex flex-wrap">
                                <div className="col-12 col-lg-6">
                                    <label>Assunto:</label>
                                    <input
                                        type="search"
                                        name="assunto"
                                        placeholder="Assunto"
                                        className={`form-control px-0 p-2 placeholder-muted-75 ${formState.errors.assunto &&
                                            "is-invalid"
                                            }`}
                                        onChange={handleErase}
                                        defaultValue="Envio de Boleto"
                                        value={valueAssunto}
                                        ref={register()}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <label>Template de Email:</label>
                                    <LazySelect
                                        controller={
                                            listarDocumentosTemplateSimples
                                        }
                                        getDS={(d) => d.DS_DOCUMENTO}
                                        getKeyValue={(d) =>
                                            d.ID_DOCUMENTO_TEMPLATE
                                        }
                                        className={`form-control placeholder-dark-50  ${formState.errors.ID_MODELO_EMAIL &&
                                            "is-invalid"
                                            }`}
                                        name="ModeloEmail"
                                        ref={register({
                                            valueAsNumber: true,
                                        })}
                                        onChange={(e) => {
                                            setAssunto(Number(e.target.value));
                                            setVariaveisDocumento(
                                                e.target.value
                                            );
                                        }}
                                    >
                                        <option value={0}>
                                            Modelo de email
                                        </option>
                                    </LazySelect>
                                </div>

                                <div className="col-12 d-flex alig-items-center justify-content-center my-2">
                                    {!siengeMode ? (
                                        <Switch
                                            color="success"
                                            label="Agrupar em Arquivo Único"
                                            labelPosition="top"
                                            type="checkbox"
                                            name="agruparAnexo"
                                            defaultChecked={true}
                                            ref={register()}
                                        />
                                    ) : (
                                        props.lstParcelasBoletosRequest.length >
                                        0 && (
                                            <span>
                                                Enviando boleto da parcela{" "}
                                                {
                                                    props
                                                        .lstParcelasBoletosRequest[0]
                                                        .NumParc_Prc
                                                }
                                            </span>
                                        )
                                    )}
                                </div>
                                <div className="col-12 h-100">
                                    <Controller
                                        name="DS_MENSAGEM"
                                        defaultValue=""
                                        control={control}
                                        render={(field) => (
                                            <Editor
                                                defaultValue=""
                                                value={field.value ?? ""}
                                                onChange={field.onChange}
                                                onBlur={field.onBlur}
                                                placeholder="Corpo do email"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            {loading ? (
                                <button
                                    type="button"
                                    className="btn btn-outline-primary font-weight-bold d-flex col-12 justify-content-center m-1"
                                    disabled={true}
                                >
                                    <div className="row px-4">
                                        <div className="loading-component">
                                            <div
                                                className="spinner-border spinner-border-sm text-primary"
                                                role="status"
                                            >
                                                <span className="sr-only">
                                                    Carregando...
                                                </span>
                                            </div>
                                        </div>
                                        <div className="ml-2">
                                            Enviar por email
                                        </div>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    className="btn btn-outline-primary font-weight-bold d-flex col-12 justify-content-center m-1"
                                    disabled={
                                        loadingVariaveisDocumento ||
                                        loading ||
                                        CadastrarHistoricoLoading ||
                                        GerarPdfESolutionLoading
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={faPaperPlane}
                                        size="lg"
                                        className="mr-1"
                                    />{" "}
                                    Enviar por email
                                </button>
                            )}
                        </form>
                    </div>
                </Collapse>
            </OrSpinner>
        </>
    );
}
